import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import type { FuelInsight } from "@/lib/fuel-analytics";

const toneStyles: Record<FuelInsight["tone"], string> = {
  neutral: "border-border bg-canvas",
  positive: "border-emerald-200 bg-emerald-50/80",
  warning: "border-amber-200 bg-amber-50/80",
};

export function FuelInsightsPanel({ insights }: { insights: FuelInsight[] }) {
  if (insights.length === 0) return null;

  return (
    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
      {insights.map((insight, index) => {
        const className = `rounded-2xl border p-4 text-left transition ${toneStyles[insight.tone]} ${
          insight.href ? "cursor-pointer hover:scale-[1.01] hover:shadow-sm" : ""
        }`;

        const content = (
          <>
            <div className="flex items-start justify-between gap-2">
              <p className="text-sm font-bold text-foreground">{insight.title}</p>
              {insight.href ? <ChevronRight className="mt-0.5 h-4 w-4 shrink-0 text-muted" /> : null}
            </div>
            <p className="mt-1 text-sm text-muted">{insight.detail}</p>
          </>
        );

        return (
          <motion.div
            key={insight.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.06, duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            {insight.href ? (
              <Link to={insight.href} className={`${className} block w-full`}>
                {content}
              </Link>
            ) : (
              <div className={className}>{content}</div>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}
